import symbolName from "@/util/symbol-name.mjs";

const maxKeysSymbol = symbolName("max-keys");
const internalMapSymbol = symbolName("internal-map");

const handlers = {
  set: lruSet,
  get: lruGet,
  ownKeys: lruOwnKeys,
  getOwnPropertyDescriptor: lruGetOwnPropertyDescriptor,
};

function lruGet(target, key) {
  return target[internalMapSymbol].get(key);
}

function lruOwnKeys(target) {
  return Array.from(target[internalMapSymbol].keys()) as Array<string>;
}

function lruGetOwnPropertyDescriptor(target, key) {
  return {
    enumerable: true,
    configurable: true,
    value: target[internalMapSymbol].get(key),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function lruSet(target: object, propertyKey: PropertyKey, value: any) {
  const maxKeys = target[maxKeysSymbol];
  const internalMap = target[internalMapSymbol];
  if (internalMap.size >= maxKeys && !internalMap.get(propertyKey)) {
    const firstKey = internalMap.keys().next().value;
    internalMap.delete(firstKey);
  }
  internalMap.set(propertyKey, value);
  return true;
}

/**
 * Creates a proxy object that aggressively removes keys if they overflow.
 */
function lruObject(obj = {}, maxKeys = 100) {
  obj[maxKeysSymbol] = maxKeys;
  const entries = Object.entries(obj);
  obj[internalMapSymbol] = new Map(entries);
  for (const [key] of entries) {
    delete obj[key];
  }
  const proxy = new Proxy(obj, handlers);
  return proxy;
}

export default lruObject;
